import React from "react";
import moment from "moment";
import inflection from "inflection";

import makeStyles from "@material-ui/styles/makeStyles";
import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";

import ErrorIcon from "@material-ui/icons/ErrorOutline";

import { PageHeader, PageFooter, Button } from "jazasoft";

import CardHeader from "../../components/CardHeader";
import useQuery from "../../hooks/useQuery";
import { LicenseType } from "../../constants";

import LicenseHistory from "./LicenseHistory";
import { humanizeNumber } from "../../utils/helpers";

const useStyles = makeStyles({
  content: {
    margin: "1.5em"
  },
  message: {
    fontSize: "1.8em"
  }
});

const License = props => {
  const [version, setVersion] = React.useState(0);
  const classes = useStyles();

  const { loading, data } = useQuery({ url: "license", params: { action: version === 0 ? "fetch" : "refresh" } });

  const license = data || {};
  const entitlementList = license.entitlements ? JSON.parse(license.entitlements) : [];
  // const entitlementListUtilised = license.entitlementsUtilised ? JSON.parse(license.entitlementsUtilised) : [];
  let items = [
    { label: "License Code", value: license.productCode },
    { label: "License Type", value: license.licenseType },
    { label: "License Flavour", value: license.licenseFlavour },
    { label: "Purchased On", value: moment(license.activatedOn).format("ll") },
    // { label: "Activated On", value: moment(license.activatedOn).format("ll") },
    { label: "Last Renewed On", value: moment(license.lastRenewedOn).format("ll") },
    {
      label: `${license.licenseType === LicenseType.PERPETUAL ? "AMC" : "Subscription"} Expiring On`,
      value:
        license.licenseType === LicenseType.PERPETUAL
          ? moment(license.lastRenewedOn).add(license.amcValidity, "days").format("ll")
          : moment(license.lastRenewedOn).add(license.subscriptionValidity, "days").format("ll")
    },
    {
      label: "Entitlement",
      value: entitlementList
        .map(e => `${inflection.humanize(e.entitlementType)}: ${humanizeNumber(e.entitlementValue)} ${e.unit}s`)
        .join("")
    },
    // {
    //   label: "Entitlement Utilised",
    //   value: entitlementListUtilised
    //     .map(e => `${inflection.humanize(e.entitlementType)}: ${humanizeNumber(e.entitlementValue)} ${e.unit}s`)
    //     .join("")
    // }
  ];

  let alert;
  if (!loading && !data) {
    alert = "Product license does not exists. Contact Support team for purchasing license.";
  }
  if (license) {
    if (license.licenseType === LicenseType.PERPETUAL) {
      if (moment().endOf("day").isAfter(moment(license.lastRenewedOn).add(license.amcValidity, "days").endOf("day"))) {
        alert = `Annual Maintenance Contract (AMC) expired on ${moment(license.lastRenewedOn)
          .add(license.amcValidity, "days")
          .format("ll")}. Contact Support team for renewing AMC.`;
      }
    } else if (
      moment()
        .endOf("day")
        .isAfter(moment(license.lastRenewedOn).add(license.subscriptionValidity, "days").endOf("day"))
    ) {
      alert = `Subscription expired on ${moment(license.lastRenewedOn)
        .add(license.subscriptionValidity, "days")
        .format("ll")}. Contact Support team for renewing Subscription.`;
    }
  }
  return (
    <div>
      <PageHeader title="License" />

      {alert && (
        <div className={classes.content}>
          <Alert classes={{ message: classes.message }} icon={<ErrorIcon fontSize="large" />} severity="error">
            {alert}
          </Alert>
        </div>
      )}

      {data && (
        <div className={classes.content}>
          <Card>
            <CardHeader title="License Details" />
            <Divider />
            <div>
              <List>
                {items.length > 0 &&
                  items.map(e => (
                    <ListItem key={e.label} button>
                      <ListItemText primary={e.label} />
                      <ListItemSecondaryAction>
                        <Typography component="div">{e.value}</Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
              </List>
            </div>
          </Card>
          <Card style={{ marginTop: "1.5em" }}>
            <CardHeader title="License History" />
            <Divider />
            <div>
              <LicenseHistory record={license} />
            </div>
          </Card>
        </div>
      )}

      <PageFooter style={{ marginLeft: "1.5em" }}>
        <Button label="Refresh" variant="contained" color="primary" onClick={() => setVersion(version + 1)} />
      </PageFooter>
    </div>
  );
};

export default License;
